import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowDown, Info, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { Nav, Footer } from "@/pages/Landing";
import { ResultExplain } from "@/components/ResultExplain";
import { Overview, DiscProfile, Gifts, Together } from "@/components/sample/SampleSections";
import { Matches, ServingProfile, AdminExperience, Conversion } from "@/components/sample/SampleMore";

const Intro = () => (
  <section className="relative grain overflow-hidden" data-testid="sample-intro">
    <div className="max-w-4xl mx-auto px-5 sm:px-6 pt-20 md:pt-28 pb-14 text-center relative">
      <p className="eyebrow fade-up">Sample Assessment Results</p>
      <h1 className="font-display text-navy font-semibold tracking-tight text-4xl sm:text-5xl lg:text-6xl mt-5 leading-[1.05] fade-up d1">
        See Where You're <span className="font-accent text-teal">Designed to Thrive.</span>
      </h1>
      <p className="text-muted-ink text-base md:text-lg leading-relaxed max-w-2xl mx-auto mt-7 fade-up d2">
        Wondering what your volunteers will discover? Explore a sample Dream Teams assessment and see how personality, spiritual gifts, and ministry matching come together to help people find their place to serve.
      </p>
      <p className="flex gap-2.5 text-left text-sm text-navy bg-white/80 border border-line rounded-xl px-4 py-3 max-w-xl mx-auto mt-7 fade-up d3" data-testid="sample-notice">
        <Info size={18} className="text-teal shrink-0 mt-0.5" />
        <span><strong>Meet Jordan.</strong> Jordan is a fictional volunteer created to demonstrate the Dream Teams assessment experience. These sample results illustrate the reports your church can receive.</span>
      </p>
      <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4 mt-10 fade-up d4">
        <button type="button" onClick={() => document.getElementById("report")?.scrollIntoView({ behavior: "smooth" })} className="btn-navy inline-flex items-center justify-center gap-2" data-testid="sample-explore-btn">
          Explore Sample Results <ArrowDown size={18} />
        </button>
        <Link to="/free-assessment" className="btn-ghost text-center" data-testid="sample-free-assessment-btn">Take the Free DISC Assessment</Link>
      </div>
    </div>
  </section>
);

export default function SampleResults() {
  const [v, setV] = useState(null);
  const [ref, setRef] = useState(null);
  useEffect(() => {
    document.title = "Sample Results · Dream Teams";
    api.get("/sample-results").then((r) => setV(r.data));
    api.get("/reference", { params: { lang: "en" } }).then((r) => setRef(r.data));
  }, []);
  return (
    <div className="bg-paper min-h-screen overflow-x-hidden">
      <Nav />
      <Intro />
      <main id="report" className="max-w-6xl mx-auto px-4 sm:px-6 space-y-6 scroll-mt-24" data-testid="sample-report">
        {!v || !ref ? <div className="py-24 flex justify-center"><Loader2 className="animate-spin text-teal" /></div> : <>
          <Overview v={v} />
          <DiscProfile v={v} />
          <ResultExplain v={{ ...v, gift_scores: [] }} reference={ref} lang="en" />
          <Gifts v={v} reference={ref} />
          <Together v={v} />
          <Matches v={v} />
          <ServingProfile v={v} />
        </>}
      </main>
      <AdminExperience />
      <Conversion />
      <Footer />
    </div>
  );
}
